var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("c-tab", {
        attrs: {
          type: "tabcard",
          align: "left",
          inlineLabel: true,
          tabItems: _vm.tabItems,
          height: "500px",
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (tab) {
              return [
                _c(tab.component, {
                  tag: "component",
                  attrs: { selectProcessCd: _vm.popupParam.selectProcessCd },
                  on: {
                    "update:selectProcessCd": function ($event) {
                      return _vm.$set(_vm.popupParam, "selectProcessCd", $event)
                    },
                    "update:select-process-cd": function ($event) {
                      return _vm.$set(_vm.popupParam, "selectProcessCd", $event)
                    },
                  },
                }),
              ]
            },
          },
        ]),
        model: {
          value: _vm.tab,
          callback: function ($$v) {
            _vm.tab = $$v
          },
          expression: "tab",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }